import theme from "../../theme";

export const style = {
  SECTION: {
    background: theme.foregroundColor,
  },
  SECTION_INNER: {
    margin: "0 auto",
    mobile: {
      desktop: {
        padding: 100,
        width: 550,
      },
      smartphone: {
        padding: 30,
        width: "100%",
      },
    },
  },
  HEADLINE: {
    textAlign: "center",
    mobile: {
      desktop: {
        fontSize: "32pt",
      },
      smartphone: {
        fontSize: "28pt",
      },
    },
    fontFamily: "Poppins",
    fontWeight: "bold" as "bold",
    paddingBottom: 10,
    color: theme.backgroundColor,
  },
  TEXT: {
    textAlign: "center",
    fontFamily: theme.fontFamily,
    fontSize: "13pt",
    lineHeight: "18pt",
    padding: "20px 0",
  },
  FORM_FIELD: {
    style: {
      padding: 10,
      maxWidth: "100%",
      paddingRight: 20,
    },
    inputStyle: {
      width: "100%",
      padding: 15,
      border: "1px solid #DDD",
      borderRadius: 4,
    },
    labelStyle: {
      fontFamily: theme.fontFamily,
      fontSize: "10pt",
      textAlign: "left",
      padding: 5,
    },
  },
  BUTTON: {
    style: {
      display: "inline-block",
      padding: 15,
      marginTop: 40,
      border: "none",
      backgroundColor: theme.backgroundColor,
      width: "100%",
      borderRadius: 3,
      cursor: "pointer",
    },
    caption1: {
      color: theme.foregroundColor,
      fontWeight: "bold" as "bold",
      fontSize: "10pt",
    },
  },
};
